module.exports = __webpack_public_path__ + "media/fonts/SFProText-Medium-4ab18c7b569d238879cf646297f2b930.ttf";